module.exports = __webpack_public_path__ + "dc62df30ae1261ae046a967e11a7aea2.svg";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/open-sans-semibold-italic.svg
// module id = 1543
// module chunks = 0